import i18n from "../i18n";

// All store amounts are Saudi Riyal. Prices were previously rendered with a
// hardcoded "$", which mislabeled every SAR amount as dollars.
//
// Latin digits are forced (`nu-latn`) so numbers stay consistent with the rest
// of the tables, and the Gregorian calendar is forced for Arabic dates because
// `ar-SA` otherwise defaults to the Umm al-Qura (Hijri) calendar in some
// engines, which would surprise anyone comparing dates with the database.

const isArabic = () => (i18n.language || "en").startsWith("ar");

export const formatSAR = (amount) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return "-";
  try {
    return new Intl.NumberFormat(isArabic() ? "ar-SA-u-nu-latn" : "en-US", {
      style: "currency",
      currency: "SAR",
    }).format(value);
  } catch (error) {
    return `${value.toFixed(2)} SAR`;
  }
};

export const formatDate = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return "-";
  try {
    return new Intl.DateTimeFormat(
      isArabic() ? "ar-SA-u-ca-gregory-nu-latn" : "en-GB"
    ).format(d);
  } catch (error) {
    return d.toLocaleDateString("en-GB");
  }
};
